<template>
  <form class="form-signin" @submit="onSubmit">
    <div class="text-center mb-4">
      <img class="mb-4" src="@/assets/nithra_loader-big.gif" alt="" width="72"
           height="72">
      <h5 class="h5 mb-3 font-weight-normal">NITHRA MESSAGING PORTAL</h5>
      <small>Area where our services are delivered to our customers through whatsapp. Only authorized users can login to
        use this area.,
        <code>To use our nithra users login credentials</code> </small>
    </div>

    <div class="form-label-group">
      <label for="inputEmail">User name</label>
      <input type="text" id="inputEmail" class="form-control" minlength="5" maxlength="20" placeholder="User name"
             v-model="form.userTGname" required="" autofocus="">
    </div>

    <div class="form-label-group">
      <label for="inputPassword">Password</label>
      <input type="password" id="inputPassword" class="form-control" minlength="5" maxlength="20" placeholder="Password"
             v-model="form.userTGpass" required="">
    </div>
    <button class="btn btn-lg btn-primary btn-block mt-3" type="submit">Sign in</button>
    <p class="mt-5 mb-3 text-muted text-center">NITHRA</p>
  </form>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        userTGname: '',
        userTGpass: ''
      },
      validated: true
    }
  },
  async created() {
    this.end_loading();
    localStorage.removeItem('NMPUSER')
  },
  methods: {
    async onSubmit(event) {
      var responseTitle;
      event.preventDefault()
      // const NMPUSER = localStorage.getItem('NMPUSER')
      const config = {}
      await axios.post('/users/loginCredentials',
          this.form, // the data to post
          config).then(response => {
        if (response.data.status) {
          localStorage.setItem('NMPUSER', JSON.stringify({
            userTGname: response.data.userTGname,
            token: response.data.token
          }));
          this.$router.push('/bulk/message/' + response.data.token);
          responseTitle = {title: "Success", message: response.data.message, icon: "success"};
        } else {
          localStorage.removeItem('NMPUSER');
          responseTitle = {title: "Failed", message: response.data.message, icon: "error"};
        }
      }).catch(function (error) {
        if (error.response) {
          responseTitle = {title: "Failed", message: error.response.data.message, icon: "error"};
        } else {
          responseTitle = {title: "Failed", message: "Something went wrong!", icon: "error"};
        }
      });
      this.$swal({
        title: responseTitle.title,
        html: responseTitle.message,
        icon: responseTitle.icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      this.form = {
        userTGname: '',
        userTGpass: ''
      };
    }
  }
}
</script>
<style>
.form-signin {
  width: 100%;
  max-width: 420px;
  padding: 15px;
  margin: 0 auto;
}
</style>
